'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');
var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var EncryptApi = function (_BaseApi) {
  (0, _inherits3.default)(EncryptApi, _BaseApi);
  function EncryptApi() {
    (0, _classCallCheck3.default)(this, EncryptApi);
    return (0, _possibleConstructorReturn3.default)(this, (EncryptApi.__proto__ || Object.getPrototypeOf(EncryptApi)).call(this, _frontendUtils.endpoints.billingBaseUrl));
  }
  (0, _createClass3.default)(EncryptApi, [{
    key: 'create',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var username = _ref2.username,
          password = _ref2.password;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (ValidationUtils.isNonEmptyOrBlankString(username)) {
                  _context.next = 2;
                  break;
                }
                throw new _ParameterError2.default('username', username, 'username string.');
              case 2:
                if (ValidationUtils.isNonEmptyOrBlankString(password)) {
                  _context.next = 4;
                  break;
                }
                throw new _ParameterError2.default('password', password, 'password string.');
              case 4:
                return _context.abrupt('return', this.makeRequest({
                  method: 'POST',
                  url: 'encryption/encryptcredentials',
                  body: {
                    username: username,
                    password: password
                  }
                }));
              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function create(_x) {
        return _ref.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: 'createObject',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(objectToEncrypt) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (ValidationUtils.isObject(objectToEncrypt)) {
                  _context2.next = 2;
                  break;
                }
                throw new _ParameterError2.default('objectToEncrypt', objectToEncrypt, 'JS object to encrypt');
              case 2:
                return _context2.abrupt('return', this.makeRequest({
                  method: 'POST',
                  url: 'encryption/encrypt',
                  body: objectToEncrypt
                }));
              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function createObject(_x2) {
        return _ref3.apply(this, arguments);
      }
      return createObject;
    }()
  }, {
    key: 'createValue',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(valueToEncrypt) {
        var bodyObject;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (ValidationUtils.isNonEmptyOrBlankString(valueToEncrypt)) {
                  _context3.next = 2;
                  break;
                }
                throw new _ParameterError2.default('valueToEncrypt', valueToEncrypt, 'string to encrypt');
              case 2:
                bodyObject = {
                  value: valueToEncrypt
                };
                return _context3.abrupt('return', this.makeRequest({
                  method: 'POST',
                  url: 'encryption/encrypt',
                  body: bodyObject
                }));
              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function createValue(_x3) {
        return _ref4.apply(this, arguments);
      }
      return createValue;
    }()
  }]);
  return EncryptApi;
}(_BaseApi3.default);
exports.default = EncryptApi;